/* istanbul ignore file */
import { number as codecNumber, string as codecString } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const CouponDataParserParser = /* #__PURE__ */ parsers.object([
    ['limit', /* #__PURE__ */ parsers.maybeNull(codecNumber)],
    ['code', codecString],
]);
export class CouponDataParser extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return CouponDataParserParser.decode(input).map(res => new CouponDataParser(res));
    }
    static unsafeDecode(input) {
        return CouponDataParser.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return CouponDataParserParser.encode(data);
    }
    static schema() {
        return CouponDataParserParser.schema();
    }
}
